import type { NavLinkProps } from 'react-router-dom';
import { Badge } from '@ff-it/ui';
import { activityTypeOptions } from 'options';
import type { ActivityType } from 'types';

export type ProductTypeCounts = Partial<Record<ActivityType, number>>;

export function productTypesForOutletOrServiceCategory(
  outletOrServiceCategoryType: ActivityType | null,
): ActivityType[] {
  return outletOrServiceCategoryType ? [outletOrServiceCategoryType] : activityTypeOptions.map(({ value }) => value);
}

export function firstProductType(
  outletOrServiceCategoryType: ActivityType | null,
  counts: ProductTypeCounts,
): ActivityType {
  const types = productTypesForOutletOrServiceCategory(outletOrServiceCategoryType);
  return types.find((type) => (counts[type] ?? 0) > 0) ?? types[0];
}

export function productTypeNavItems(
  outletOrServiceCategoryType: ActivityType | null,
  counts: ProductTypeCounts,
): NavLinkProps[] {
  return productTypesForOutletOrServiceCategory(outletOrServiceCategoryType).map((type) => {
    const option = activityTypeOptions.find(({ value }) => value === type);

    return {
      to: `products/${type}`,
      children: (
        <>
          {option?.label ?? type} <Badge variant="secondary" count={counts[type] ?? 0} />
        </>
      ),
    };
  });
}
